import { useEffect, useState } from 'react';
import { getAccessToken } from '../services/authService';

const denied = { canEdit: false, canUseAI: false, canManage: false, permission: null, ready: false };
export default function useScriptAccess(documentId, supplied) {
  const [access, setAccess] = useState(denied);
  useEffect(() => {
    if (supplied || !documentId) return;
    let mounted = true;
    const load = async () => {
      try {
        const token = getAccessToken();
        if (!token) { if (mounted) setAccess({ ...denied, ready: true }); return; }
        const res = await fetch(`${process.env.REACT_APP_DEV_API}/document/${documentId}/permission`, { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) throw new Error('Script access unavailable');
        const body = await res.json();
        if (mounted) setAccess({ ...(body.data || denied), ready: true });
      } catch (_) { if (mounted) setAccess({ ...denied, ready: true }); }
    };
    setAccess(denied);
    load();
    const timer = setInterval(load, 30000);
    window.addEventListener('focus', load);
    window.addEventListener('subscription-updated', load);
    return () => { mounted = false; clearInterval(timer); window.removeEventListener('focus', load); window.removeEventListener('subscription-updated', load); };
  }, [documentId, supplied]);
  return supplied || access;
}